import { Component } from '@angular/core';

@Component({
    selector: 'green-brush-character',
    templateUrl: '../../../../../../src/assets/svgs/characters/greenbrush.svg',
    styleUrls: ['../svg.component.scss']
})
export class GreenBrushCharacter {

}